import { IConversation, IMember } from "@auvious/integrations";
import { Component, ComponentInterface, h, Prop, State } from "@stencil/core";
import { store, Unsubscribe } from "@stencil/redux";

import { CallStateEnum } from "../../../models";
import { RootState } from "../../../store/states";
import { AppConfigService, TranslateService } from "../../../services";

@Component({
  tag: "av-agent",
  styleUrl: "av-agent.scss",
  shadow: true,
})
export class AvAgent implements ComponentInterface {
  @Prop() emptyDisplayName: string;
  @Prop() isTray = true;

  @State() isConversationIdVisible = false;

  // store
  @Prop({ mutable: true }) $agent: IMember;
  @Prop({ mutable: true }) $callState: CallStateEnum;
  @Prop({ mutable: true }) $isAgentMuted: boolean;
  @Prop({ mutable: true }) $conversationData: IConversation;

  storeUnsubscribe: Unsubscribe;

  connectedCallback() {
    if (this.storeUnsubscribe) this.storeUnsubscribe();

    this.storeUnsubscribe = store.mapStateToProps(
      this,
      (rootState: RootState) => {
        const {
          conversation: { agent, data },
          call: { state, isAgentMuted },
        } = rootState;
        return {
          $agent: agent,
          $callState: state,
          $isAgentMuted: isAgentMuted,
          $conversationData: data,
        };
      }
    );
  }

  disconnectedCallback() {
    this.storeUnsubscribe();
  }

  toggleName() {
    this.isConversationIdVisible = !this.isConversationIdVisible;
  }

  get isCallHold() {
    return this.$callState === CallStateEnum.onHold;
  }

  render() {
    const noAgentName = !!this.emptyDisplayName
      ? TranslateService.instant(this.emptyDisplayName)
      : TranslateService.instant("Agent");

    return (
      <div class={{ "av-agent": true, "av-agent-tray": this.isTray }}>
        {this.$isAgentMuted && (
          <av-asset
            data-tid="agent/mic-muted"
            class={{
              "av-agent-icon": true,
              "av-agent-muted": !!this.$agent?.avatarImageUrl,
            }}
            image="mic-muted"
            // onClick={this.toggleName.bind(this)}
          ></av-asset>
        )}
        {this.$agent?.avatarImageUrl &&
          AppConfigService.agentInfoEnabled && (
            <div class="av-agent-avatar">
              <img
                data-tid={this.isCallHold ? "agent/on-hold" : "agent/online"}
                aria-hidden="true"
                class={{
                  "av-agent-avatar": true,
                  "av-agent-avatar-hold": this.isCallHold,
                }}
                // onClick={this.toggleName.bind(this)}
                src={this.$agent.avatarImageUrl}
              />
              <slot name="agent-avatar"></slot>
            </div>
          )}
        {(!this.$agent?.avatarImageUrl ||
          !AppConfigService.agentInfoEnabled) &&
          !this.$isAgentMuted && (
            <div class="av-agent-avatar">
              <av-asset
                data-tid="agent/online"
                class="av-agent-icon"
                image="user"
                // onClick={this.toggleName.bind(this)}
              ></av-asset>
              <slot name="agent-avatar"></slot>
            </div>
          )}
        {/* </span>
        } */}
        {/* {(!this.$agent.avatarImageUrl) &&
          <div class="av-agent-spacer"></div>
        } */}
        <div>
          {!this.isConversationIdVisible &&
            this.$agent?.displayName &&
            AppConfigService.agentInfoEnabled && (
              <div>{this.$agent.displayName}</div>
            )}
          {!this.isConversationIdVisible &&
            (!this.$agent?.displayName ||
              !AppConfigService.agentInfoEnabled) && (
              <div>{noAgentName}</div>
            )}
          {this.isConversationIdVisible && (
            <div class="av-agent-cid">{this.$conversationData?.id}</div>
          )}
          <small>
            <slot></slot>
          </small>
        </div>
      </div>
    );
  }
}
